import { mapGetters } from 'vuex'

export default {
  name: 'LavenderMixin',
  computed: {
    ...mapGetters('session', { sessionOrder: 'order' }),
    isLavenderReskinEnabled() {
      return this.sessionOrder?.isLavenderDesignEnabled ?? false
    },
  },
}
